import type { ResultCardCard } from 'screens/Main/Search/Components/ResultCard';
import type { Activity } from 'types/interfaces/activity';

/**
 * The feed item's card, in the shape the Search tile reads (Asana
 * 1219036410957400). The backend already names the fields as search-light
 * does, so this is a projection, not a translation: the feed's `imageUrl`
 * becomes `imageUris.normal` and `scryfallId` is mirrored onto `scryfallID`
 * for the helpers that read the typed casing.
 *
 * Deliberately NOT copied: `activity.pointValue`. It is the event's own value
 * (a locked trade price or a want's price) and it renders in the meta row under
 * the tile; the tile's non-foil fallback reads `card.pointValue`, so copying it
 * would show a trade's locked price as the printing's price for an unpriced
 * non-foil finish instead of "???".
 */
export const feedCardToTile = (activity: Activity): ResultCardCard => {
  const { card } = activity;
  return {
    id: card.id,
    name: card.name,
    scryfallId: card.scryfallId,
    scryfallID: card.scryfallId,
    setCode: card.setCode,
    setName: card.setName,
    setIconUrl: card.setIconUrl ?? undefined,
    collectorNumber: card.collectorNumber,
    printedName: card.printedName ?? null,
    flavorName: card.flavorName ?? null,
    finishes: card.finishes,
    promoTypes: card.promoTypes,
    nonFoilPoints: card.nonFoilPoints,
    foilPoints: card.foilPoints,
    etchedPoints: card.etchedPoints,
    holderCount: card.holderCount,
    wantedCount: card.wantedCount,
    imageUris: card.imageUrl ? { normal: card.imageUrl } : undefined,
  };
};

export default feedCardToTile;
